<template>
  <div>
    <div class="d-flex align-items-start" >
      <LeftMenu @show="show" showTA showAdminTable showUsersTable/>
      <div v-if="whatShow === '1'" class="tab-pane active" id="left-admin" role="tabpanel" aria-labelledby="left-admin-tab">
        <Employee/>
      </div>
      <div v-if="whatShow === '2'" class="tab-pane active" id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
        <Finance/>
      </div>
      <div v-if="whatShow === '3'" class="tab-pane active" id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
        <TransportAccounting role="admin"/>
      </div>
      <div v-if="whatShow === '4'" class="tab-pane active" id="left-user" role="tabpanel" aria-labelledby="left-user-tab">
        <AtiCarrier/>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref, onMounted } from 'vue'
import LeftMenu from '@/components/LeftMenu.vue'
import TransportAccounting from '@/components/tables/TransportAccounting.vue'
import Employee from '@/components/tables/Employee.vue'
import Finance from '@/components/tables/Finance.vue'
import { useRouter } from 'vue-router'
import AtiCarrier from "@/components/tables/AtiCarrier.vue";

const router = useRouter()

const whatShow = ref('1')

onMounted(() => {
  console.log("admin mounted");
  if (localStorage.getItem('role') !== 'ROLE_ADMIN') {
    router.push('admin/userPage');
  }
})

function show(n) {
  whatShow.value = n;
}

</script>

<style scoped>

</style>